import React from "react";
import Hero from "./hero";
import AnchoringConversations from "./anchoring_conversations";
import Partners from "./partners";
import ContactUs from "./contact_us";
import About from "./about";
import Newsletter from "./newsletter";

type Props = {};

const Home = (props: Props) => {
  return (
    <>
      <Hero />
      <About />
      <AnchoringConversations />
      <Newsletter />
      <Partners />
      <ContactUs />
    </>
  );
};

export default Home;
